import UpdateTicker from "@/pages/home/components/UpdateTicker";
import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroCover from "@/pages/home/components/HeroCover";
import ContentsSection from "@/pages/home/components/ContentsSection";
import FormatSection from "@/pages/home/components/FormatSection";
import EntryPanel from "@/pages/home/components/EntryPanel";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";
import {
  commentaryItems,
  condensedItems,
  mashupItems,
} from "@/mocks/home";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 flex flex-col">
      <UpdateTicker />
      <SiteHeader />

      <main className="flex-1">
        <HeroCover />
        <ContentsSection />

        <FormatSection
          id="commentary"
          kicker="解说 · 字幕版"
          title="跟不上的段落，字幕先兜住"
          description="口播节奏放慢，人名和地点先交代背景，关键段落单独加字幕，第一次看也不容易绕晕。"
          items={commentaryItems}
          layout="list"
          tone="tinted"
          icon="ri-chat-voice-line"
        />

        <FormatSection
          id="condensed"
          kicker="浓缩速看"
          title="只留主干，通勤一趟能刷完"
          description="把铺垫和来回绕的部分砍掉，只保留转折与结果，每条基本控制在十五分钟以内。"
          items={condensedItems}
          layout="grid"
          tone="plain"
          icon="ri-timer-flash-line"
        />

        <FormatSection
          id="mashup"
          kicker="混剪 · 剪辑"
          title="同一分钟发生了什么，对齐着看"
          description="把多个视角或不同时间的画面放到同一条时间轴上，前后差别一眼能对上。"
          items={mashupItems}
          layout="list"
          tone="tinted"
          icon="ri-scissors-cut-line"
        />

        <EntryPanel />
        <FaqSection />
      </main>

      <SiteFooter />
    </div>
  );
}